import CustomCampaignUrl from './CustomCampaignUrl';

export default CustomCampaignUrl;
